import { Building2, FileText, History, LayoutDashboard, MessageSquare, Wallet } from 'lucide-react';
import { AppShell } from '../../components/AppShell.tsx';
import type { NavItem } from '../../components/Sidebar.tsx';
import { useThreadCounts } from '../../lib/messages.ts';

const ITEMS: NavItem[] = [
  { to: '/vuokranantaja', labelKey: 'nav.overview', icon: LayoutDashboard, end: true },
  { to: '/vuokranantaja/asunnot', labelKey: 'nav.properties', icon: Building2 },
  { to: '/vuokranantaja/talous', labelKey: 'nav.finance', icon: Wallet },
  { to: '/vuokranantaja/viestit', labelKey: 'nav.messages', icon: MessageSquare },
  { to: '/vuokranantaja/verot', labelKey: 'nav.taxes', icon: FileText },
  { to: '/vuokranantaja/historia', labelKey: 'nav.history', icon: History },
];

/** Vuokranantaja: yleiset sivut sivupaneelissa, asuntokohtaiset välilehtinä asunnon sivulla. */
export function LandlordShell() {
  const { data: counts } = useThreadCounts('owner');
  const items = ITEMS.map((item) =>
    item.to === '/vuokranantaja/viestit' ? { ...item, badge: counts?.unreadThreads } : item,
  );
  return <AppShell items={items} home="/vuokranantaja" />;
}
